
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { RevTag } from '@ds/components/Tag'

import ProductCardRatings from '@landing/components/ProductCardRatings/ProductCardRatings.vue'

import AttributesList from './AttributesList.vue'
import translations from './ProductCard.translations'

export default {
  components: {
    RevCard,
    RevIllustration,
    RevTag,
    RevButtonBase,
    AttributesList,
    ProductCardRatings,
  },
  props: {
    link: { type: Object, required: true },
    tag: { type: String, default: undefined },
    imageSrc: { type: String, required: true },
    imageAlt: { type: String, required: true },
    title: { type: String, required: true },
    price: { type: Object, required: true },
    priceWhenNew: { type: Object, default: () => undefined },
    reviewRating: { type: Object, required: false, default: undefined },
    attributes: { type: Array, default: () => [] },
    colorSwatches: { type: Array, default: () => [] },
    storageTags: { type: Array, default: () => [] },
  },
  computed: {
    translations: () => translations,
  },
}
